module.exports = __webpack_public_path__ + "static/media/OnTravelSolutions.97968e58.ico";